import type { FileUIPart } from "ai";

export const FLAGS = {
  /**
   * Enable Sentry error tracking in development
   * Set to true to test Sentry integration locally
   */
  enableSentryInDev: false,
} as const;

/**
 * Session storage payload used to hand the initial prompt from Home -> Project chat.
 * Home writes this before redirecting; ChatPanel reads it once and auto-sends.
 */
export const INITIAL_MESSAGE_KEY = "slider:initialMessage";

/** Session payload stored at INITIAL_MESSAGE_KEY and consumed once by ChatPanel. */
export type InitialMessage = {
  text: string;
  files?: FileUIPart[];
};
